<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">交易机器人设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>启动-交易对配置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <Creat></Creat>
        <!-- <el-select v-model="value" clearable placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-input
          placeholder="请输入robotId"
          clearable
          v-model="fbsPair"
          @keyup.enter.native="handleSearch"
          @blur="handleSearch"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="handleSearch" type="primary" >搜索</el-button>
      </div>
      <InfoList :page="page" :size="size" :total="totalCount"></InfoList>
      <PageNation
        :total="totalCount"
        :size="size"
        :page="page"
        @pageChanged="handlePageChanged($event)"
      ></PageNation>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions,mapState } from "vuex";
import InfoList from "./components/Infolist";
import Creat from "./components/create";
import PageNation from "../../../components/pagination";

export default {
  data() {
    return {
      // totalCount:10,
      page: 1,
      size: 10,
      fbsPair: "",
     
    };
  },
  components: { InfoList, Creat, PageNation },
  computed: {
    ...mapState('RobotPairConfig',['totalCount'])
  },
  methods: {
    ...mapActions('RobotPairConfig',['getlist','getList']),
    handleSearch() {
      this.getList({robotId:this.fbsPair,page:this.page,size:this.size})
    },
    handlePageChanged(e){
      this.getList({...e,robotId:this.fbsPair})
    }
  },
};
</script>

<style lang="less" scoped></style>
